import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { PsrCustomerVulnerability } from "./psrCustomerVulnerability"
import { IPsrCustomerVulnerability } from "@/models/psr/psr.types"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"
import { PsrCustomerVulnerabilityResponse } from "@/api/backofficeRest/generated/model"

export type IPsrCustomerVulnerabilityRaw = PsrCustomerVulnerabilityResponse

export const PsrCustomerVulnerabilityParser: IParser<
  IPsrCustomerVulnerability,
  IPsrCustomerVulnerabilityRaw
> = {
  toDomain: (data: IPsrCustomerVulnerabilityRaw) => {
    try {
      return new PsrCustomerVulnerability(
        data.id,
        dayjs(data.startDate),
        // label is typed optional by the OpenAPI merge but always populated for a stored vulnerability
        data.label ?? "",
        safeDayjs(data.endDate),
        data.note ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
